/* 検索項目 ラベル */
import React, { memo } from 'react';
var SearchLabel = function (_a) {
    var label = _a.label;
    return React.createElement("span", { className: "search-criteria-head" }, label);
};
export default memo(SearchLabel);
